import { ITheme } from '@fluentui/react/lib/Styling';

import { AppColors } from '@ms/acui-common';

/* Possible variant looks for commanding UI controls */
export enum Variant {
  primary = 'primary',
  inverted = 'inverted',
  transparent = 'transparent',
}

/**
 * App themed styles required an app color palette
 * because the colors are assigned to match the palette
 */
export interface AppThemedVariant {
  variantLook: Variant.primary | Variant.inverted;
  appColors: AppColors;
  theme?: ITheme;
  omitIconDynamicColoring?: boolean;
}

/**
 * Transparent variant requires styles to be provided
 * because the look varies according to what component
 * renders their content using this variant
 */
export interface AppTransparentVariant {
  variantLook: Variant.transparent;
}

/**
 * Interface used to choose a variant
 * and provide the relevant props for it
 */
export type AppButtonVariants = AppThemedVariant | AppTransparentVariant;
